import { z } from 'zod';
const billingMode = z.enum(['PER_PALLET_DAY', 'FIXED_MONTHLY']);
const customerCode = z
    .string()
    .trim()
    .toUpperCase()
    .regex(/^[A-Z0-9]{2,16}$/, 'Customer code must be 2–16 uppercase ASCII letters or digits');
export const createCustomerSchema = z.object({
    code: customerCode,
    name: z.string().trim().min(1).max(200),
    contactPerson: z.string().trim().max(200).optional(),
    contactEmail: z.string().trim().toLowerCase().email().optional(),
    contactPhone: z.string().trim().max(40).optional(),
    billingAddress: z.string().trim().max(500).optional(),
    vatId: z.string().trim().max(40).optional(),
    billingMode: billingMode.default('PER_PALLET_DAY'),
    pricingTierId: z.string().uuid().nullable().optional(),
    // Inline per-customer tariff (WMS-14): flat cents, interpreted by billingMode
    // (per pallet/day or per month). Null clears it and falls back to the plan.
    customRateCents: z.number().int().min(0).max(100_000_000).nullable().optional(),
    notes: z.string().trim().max(2000).optional(),
});
// Update reuses create's optional shape minus the immutable code.
export const updateCustomerSchema = createCustomerSchema.partial().omit({ code: true });
export const tierBandSchema = z.object({
    fromDay: z.number().int().min(1),
    toDay: z.number().int().min(1).nullable(),
    rateCents: z.number().int().min(0),
});
export const pricingKind = z.enum(['PER_DAY', 'FIXED_MONTHLY']);
export const createPricingTierSchema = z
    .object({
    name: z.string().trim().min(1).max(120),
    scope: z.enum(['GLOBAL', 'CUSTOMER']),
    kind: pricingKind.default('PER_DAY'),
    isDefault: z.boolean().default(false),
    // Required for PER_DAY, ignored for FIXED_MONTHLY (defaults to []).
    tiers: z.array(tierBandSchema).default([]),
    // Required for FIXED_MONTHLY, ignored for PER_DAY.
    monthlyCents: z.number().int().min(0).nullable().default(null),
})
    .superRefine((val, ctx) => {
    if (val.kind === 'PER_DAY' && val.tiers.length === 0) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['tiers'],
            message: 'A per-day tariff needs at least one day band.',
        });
    }
    if (val.kind === 'FIXED_MONTHLY' && (val.monthlyCents === null || val.monthlyCents <= 0)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['monthlyCents'],
            message: 'A fixed-monthly plan needs a positive monthly amount.',
        });
    }
});
export const recordPaymentSchema = z.object({
    amountCents: z.number().int().positive(),
    currency: z.string().length(3).default('EUR'),
    paidAt: z.coerce.date(),
    periodFrom: z.coerce.date().optional(),
    periodTo: z.coerce.date().optional(),
    reference: z.string().trim().max(200).optional(),
});
//# sourceMappingURL=customer.js.map